<template>
  <video
    ref="player"
    playsinline
    :poster="posterUrl"
    :src="videoUrl"
    :width="width"
    :height="height"
    @contextmenu.prevent
  />
</template>

<script>
import 'mediaelement/build/mediaelement-and-player.min.js';

export default {
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    posterUrl: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.player = this.initializeVideoPlayer(
        this.$refs.player,
        this.posterUrl
      );
    });
  },
  methods: {
    initializeVideoPlayer(element, posterUrl) {
      const player = new MediaElementPlayer(element, {
        features: [
          'playpause',
          'progress',
          'current',
          'duration',
          'volume',
          'fullscreen',
        ],
        stretching: 'responsive',
        poster: this.posterUrl,
        alwaysShowControls: true,
        showPosterWhenEnded: true,
        hideVolumeOnTouchDevices: false,
        audioVolume: 'vertical',
        success: function (mediaElement, originalNode, instance) {
          mediaElement.addEventListener('playing', (event) => {});
        },
      });

      // Set poster and start playback.
      player.currentTime = 0;
      player.pause();
      player.load();
      player.setPoster(posterUrl);
      player.play();

      return player;
    },
  },
};
</script>

<style>
@import '../../node_modules/mediaelement/build/mediaelementplayer.min.css';

/* Pull player area and controls behind searchbar. */
.mejs__player.mini .mejs__inner .mejs__layer {
  z-index: 0;
}
.mejs__player.mini .mejs__inner .mejs__controls {
  z-index: 0;
}

/* Allow to center controls vertically. Remove shadow gradient overlay. */
.mejs__player.mini .mejs__inner .mejs__controls {
  height: 100%;
  padding: 0;
  background: none;
}

/* Adjust play/replay/pause button positions and looks. */
.mejs__player.mini
  .mejs__inner
  .mejs__controls
  .mejs__button.mejs__playpause-button.mejs__play {
  position: relative;
  margin: 0;
  padding: 0;
  background: url('../../static/btn_play.png');
  max-width: 96px;
  max-height: 54px;
  width: 100%;
  height: 100%;
}
.mejs__player.mini
  .mejs__inner
  .mejs__controls
  .mejs__button.mejs__playpause-button.mejs__play
  button {
  display: none;
}
.mejs__player.mini
  .mejs__inner
  .mejs__controls
  .mejs__button.mejs__playpause-button.mejs__replay {
  position: relative;
  margin: 0;
  padding: 0;
  background: url('../../static/btn_play.png');
  max-width: 96px;
  max-height: 54px;
  width: 100%;
  height: 100%;
}
.mejs__player.mini
  .mejs__inner
  .mejs__controls
  .mejs__button.mejs__playpause-button.mejs__replay
  button {
  display: none;
}
.mejs__player.mini
  .mejs__inner
  .mejs__controls
  .mejs__button.mejs__playpause-button.mejs__pause {
  position: relative;
  margin: 0;
  padding: 0;
  background: none;
  width: 100%;
  height: 100%;
}
.mejs__player.mini
  .mejs__inner
  .mejs__controls
  .mejs__button.mejs__playpause-button.mejs__pause
  button {
  display: none;
}

/* Make sure poster is contained in the player, otherwise it would be
   blown out to fully cover the page, which looks weird for portrait. */
.mejs__player.mini .mejs__inner .mejs__layers .mejs__poster.mejs__layer {
  background-size: contain;
}

/* Scale down the loading spinner. */
.mejs__player.mini
  .mejs__inner
  .mejs__layers
  .mejs__overlay.mejs__layer
  .mejs__overlay-loading {
  transform: scale(0.35);
}

/* Hide the big play button. */
.mejs__player.mini
  .mejs__inner
  .mejs__layers
  .mejs__overlay.mejs__layer.mejs__overlay-play
  .mejs__overlay-button {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniPreviewVideoPlayer.vue